import React, { Component } from "react";
import { Table, Form, Popup, Icon, Grid } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();
const ipRegex = new RegExp("^[0-2][0-9.]*$");
const networkTopologyRegex = new RegExp("^[A-Za-z][A-Za-z]*");

export class Network extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false
    };
  }

  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order devices by ip descending
    if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num2 - num1;
        }),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by network_topology ascending
    else if (clickedColumn === "network_topology" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "network_topology",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by network_topology descending
    else if (clickedColumn === "network_topology" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "network_topology",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by network_status ascending
    else if (clickedColumn === "network_status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "network_status",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by network_status descending
    else if (clickedColumn === "network_status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "network_status",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by acd_capable ascending
    else if (clickedColumn === "acd_capable" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "acd_capable",
            false,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by acd_capable descending
    else if (clickedColumn === "acd_capable" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "acd_capable",
            true,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by acd_status ascending
    else if (clickedColumn === "acd_status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "acd_status",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by acd_status descending
    else if (clickedColumn === "acd_status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "acd_status",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by announce_based_ring_node ascending
    else if (clickedColumn === "announce_based_ring_node" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "announce_based_ring_node",
            false,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by announce_based_ring_node descending
    else if (clickedColumn === "announce_based_ring_node" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "announce_based_ring_node",
            true,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by beacon_based_ring_node ascending
    else if (clickedColumn === "beacon_based_ring_node" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "beacon_based_ring_node",
            false,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by beacon_based_ring_node descending
    else if (clickedColumn === "beacon_based_ring_node" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "beacon_based_ring_node",
            true,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by flush_table_frame_capable ascending
    else if (clickedColumn === "flush_table_frame_capable" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "flush_table_frame_capable",
            false,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by flush_table_frame_capable descending
    else if (clickedColumn === "flush_table_frame_capable" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "flush_table_frame_capable",
            true,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by redundant_gateway_capable ascending
    else if (clickedColumn === "redundant_gateway_capable" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "redundant_gateway_capable",
            false,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by redundant_gateway_capable descending
    else if (clickedColumn === "redundant_gateway_capable" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "redundant_gateway_capable",
            true,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by supervisor_capable ascending
    else if (clickedColumn === "supervisor_capable" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "supervisor_capable",
            false,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by supervisor_capable descending
    else if (clickedColumn === "supervisor_capable" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "supervisor_capable",
            true,
            (a) => { return UtilsInstance.treatUppercase(this.getTrueFalseStringValue(a)); })),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleNetworkTopologySearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].network_topology != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].network_topology.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && networkTopologyRegex.test(this.state.formInput)) {
      this.handleNetworkTopologySearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user
    // didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {

      let networkDevices = [];

      let tcpIpInterface = await fetch(Constants.REQUEST_IP_ADDRESS + "tcpIpInterface", { mode: "cors" })
        .then(res => res.json())
        .then((data) => data);

      let deviceLevelRing = await fetch(Constants.REQUEST_IP_ADDRESS + "deviceLevelRing", { mode: "cors" })
        .then(res => res.json())
        .then((data) => data);

      for (let i = 0; i < tcpIpInterface.length; i++) {
        networkDevices.push({
          "id": tcpIpInterface[i].id,
          "ip": tcpIpInterface[i].ip,
          "acd_capable": tcpIpInterface[i].acd_capable,
          "acd_status": tcpIpInterface[i].acd_status
        });
      }

      for (let i = 0; i < deviceLevelRing.length; i++) {
        for (let j = 0; j < networkDevices.length; j++) {
          if (deviceLevelRing[i].id === networkDevices[j].id) {
            networkDevices[j].network_status = deviceLevelRing[i].network_status;
            networkDevices[j].network_topology = deviceLevelRing[i].network_topology;
            networkDevices[j].announce_based_ring_node = deviceLevelRing[i].announce_based_ring_node;
            networkDevices[j].beacon_based_ring_node = deviceLevelRing[i].beacon_based_ring_node;
            networkDevices[j].flush_table_frame_capable = deviceLevelRing[i].flush_table_frame_capable;
            networkDevices[j].redundant_gateway_capable = deviceLevelRing[i].redundant_gateway_capable;
            networkDevices[j].supervisor_capable = deviceLevelRing[i].supervisor_capable;
            break;
          }
        }
      }

      this.setState({
        devices: networkDevices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        originalDevices: networkDevices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        })
      });

    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_DIAGNOSTIC;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getTrueFalseCell(attribute) {
    if (typeof (attribute) === "boolean") {
      if (attribute === true) {
        return <Table.Cell verticalAlign="middle">{Strings.YES}</Table.Cell>;
      }
      else {
        return <Table.Cell verticalAlign="middle">{Strings.NO}</Table.Cell>;
      }
    }
    else {
      return <Table.Cell verticalAlign="middle">{attribute}</Table.Cell>;
    }
  }

  getTrueFalseStringValue(attribute) {
    if (typeof (attribute) === "boolean") {
      if (attribute === true) {
        return Strings.YES;
      }
      else {
        return Strings.NO;
      }
    }
    else {
      return attribute;
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate = () => {
    this.adjustTableMaxHeight();
  }

  // Render the table containing the network topology
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const topologyDevices = this.state.devices.map(device => (
      <Table.Row key={device.ip}>
        <Table.Cell verticalAlign="middle">{device.ip}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.network_topology}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.network_status}</Table.Cell>
        {this.getTrueFalseCell(device.acd_capable)}
        <Table.Cell verticalAlign="middle">{device.acd_status}</Table.Cell>
        {this.getTrueFalseCell(device.announce_based_ring_node)}
        {this.getTrueFalseCell(device.beacon_based_ring_node)}
        {this.getTrueFalseCell(device.flush_table_frame_capable)}
        {this.getTrueFalseCell(device.redundant_gateway_capable)}
        {this.getTrueFalseCell(device.supervisor_capable)}
      </Table.Row>
    ));

    return (
      <div style={screenStyle}>

        <Grid columns={3} verticalAlign="middle">

          <Grid.Column width={4} />

          <Grid.Column width={8}>
            <Form onSubmit={this.handleSubmit} >
              <Form.Input
                id="inputform"
                placeholder={Strings.NETWORK_INPUT_TEXT_PLACEHOLDER}
                icon="search"
                name="formInput"
                value={filter}
                onChange={this.handleChange} />
            </Form>
          </Grid.Column>

          <Grid.Column width={4} />

        </Grid>

        <Table id="table-header" style={headerMarginStyle} sortable compact stackable fixed structured celled textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell rowSpan="2"
                sorted={column === "ip" ? direction : null}
                onClick={this.handleSort("ip")}>
                {Strings.IP}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell rowSpan="2"
                    sorted={column === "network_topology" ? direction : null}
                    onClick={this.handleSort("network_topology")}>
                    {Strings.NETWORK_TOPOLOGY_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.NETWORK_TOPOLOGY_2}<br />
                    {Strings.NETWORK_TOPOLOGY_3}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.NETWORK_TOPOLOGY_POPUP_1}</p>
                  <p>{Strings.NETWORK_TOPOLOGY_POPUP_2}</p>
                  <p>{Strings.NETWORK_TOPOLOGY_POPUP_3}</p>
                  <p>{Strings.NETWORK_TOPOLOGY_POPUP_4}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell rowSpan="2"
                    sorted={column === "network_topology" ? direction : null}
                    onClick={this.handleSort("network_topology")}>
                    {Strings.NETWORK_STATUS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.NETWORK_STATUS_2}<br />
                    {Strings.NETWORK_STATUS_3}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.NETWORK_STATUS_POPUP_1}</p>
                  <p>{Strings.NETWORK_STATUS_POPUP_2}</p>
                  <p>{Strings.NETWORK_STATUS_POPUP_3}</p>
                  <p>{Strings.NETWORK_STATUS_POPUP_4}</p>
                  <p>{Strings.NETWORK_STATUS_POPUP_5}</p>
                  <p>{Strings.NETWORK_STATUS_POPUP_6}</p>
                  <p>{Strings.NETWORK_STATUS_POPUP_7}</p>
                </Popup.Content>
              </Popup>

              <Table.HeaderCell colSpan="2" disabled>{Strings.ADDRESS_CONFLICT_DETECTION}</Table.HeaderCell>
              <Table.HeaderCell colSpan="5" disabled>{Strings.RING_CAPABILITY_FLAGS}</Table.HeaderCell>
            </Table.Row>
            <Table.Row>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "acd_capable" ? direction : null}
                    onClick={this.handleSort("acd_capable")}>
                    {Strings.ACD_CAPABLE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.ACD_CAPABLE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.ACD_CAPABLE_POPUP_1}</p>
                  <p>{Strings.ACD_CAPABLE_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "acd_status" ? direction : null}
                    onClick={this.handleSort("acd_status")}>
                    {Strings.ACD_STATUS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.ACD_STATUS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.ACD_STATUS_POPUP_1}</p>
                  <p>{Strings.ACD_STATUS_POPUP_2}</p>
                  <p>{Strings.ACD_STATUS_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "announce_based_ring_node" ? direction : null}
                    onClick={this.handleSort("announce_based_ring_node")}>
                    {Strings.ANNOUNCE_BASED_RING_NODE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.ANNOUNCE_BASED_RING_NODE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.ANNOUNCE_BASED_RING_NODE_POPUP_1}</p>
                  <p>{Strings.ANNOUNCE_BASED_RING_NODE_POPUP_2}</p>
                  <p>{Strings.ANNOUNCE_BASED_RING_NODE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "beacon_based_ring_node" ? direction : null}
                    onClick={this.handleSort("beacon_based_ring_node")}>
                    {Strings.BEACON_BASED_RING_NODE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.BEACON_BASED_RING_NODE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.BEACON_BASED_RING_NODE_POPUP_1}</p>
                  <p>{Strings.BEACON_BASED_RING_NODE_POPUP_2}</p>
                  <p>{Strings.BEACON_BASED_RING_NODE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "flush_table_frame_capable" ? direction : null}
                    onClick={this.handleSort("flush_table_frame_capable")}>
                    {Strings.FLUSH_TABLE_CAPABLE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.FLUSH_TABLE_CAPABLE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.FLUSH_TABLE_CAPABLE_POPUP_1}</p>
                  <p>{Strings.FLUSH_TABLE_CAPABLE_POPUP_2}</p>
                  <p>{Strings.FLUSH_TABLE_CAPABLE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "redundant_gateway_capable" ? direction : null}
                    onClick={this.handleSort("redundant_gateway_capable")}>
                    {Strings.REDUNDANT_GATEWAY_CAPABLE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.REDUNDANT_GATEWAY_CAPABLE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.REDUNDANT_GATEWAY_CAPABLE_POPUP_1}</p>
                  <p>{Strings.REDUNDANT_GATEWAY_CAPABLE_POPUP_2}</p>
                  <p>{Strings.REDUNDANT_GATEWAY_CAPABLE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "supervisor_capable" ? direction : null}
                    onClick={this.handleSort("supervisor_capable")}>
                    {Strings.SUPERVISOR_CAPABLE_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /><br />
                    {Strings.SUPERVISOR_CAPABLE_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.SUPERVISOR_CAPABLE_POPUP_1}</p>
                  <p>{Strings.SUPERVISOR_CAPABLE_POPUP_2}</p>
                  <p>{Strings.SUPERVISOR_CAPABLE_POPUP_3}</p>
                </Popup.Content>
              </Popup>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" style={tableBorderStyle} compact stackable fixed structured celled striped textAlign="center">
            <Table.Body>
              {topologyDevices}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll",
};

const tableBorderStyle = {
  borderCollapse: "separate"
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%",
  borderCollapse: "separate"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Network);
